export enum Environment {
    local = 'local',
    staging = 'staging',
    integrations = 'integrations',
    production = 'production',
    demo = 'demo',
}

export enum BuildMode {
    production = 'production',
    development = 'development',
}

export const envConfig = {
    version: GLOBAL_CONFIG.version,
    environment: GLOBAL_CONFIG.environment,
    buildMode: GLOBAL_CONFIG.buildMode,
    isDevBuild: GLOBAL_CONFIG.buildMode === BuildMode.development,
    isProdBuild: GLOBAL_CONFIG.buildMode === BuildMode.production,
    isLocalEnv: GLOBAL_CONFIG.environment === Environment.local,
    isStagingEnv: GLOBAL_CONFIG.environment === Environment.staging,
    isIntegrationsEnv: GLOBAL_CONFIG.environment === Environment.integrations,
    isDemoEnv: GLOBAL_CONFIG.environment === Environment.demo,
    isProductionEnv: GLOBAL_CONFIG.environment === Environment.production,
};
